import { CTA } from "common/styleguide/CTA";
import React from "react";
import styles from "./Buttons.scss";

export const Buttons = () => (
  <div className={styles.Buttons}>
    <h1>Buttons</h1>
    <p>Inline CTA</p>
    <div className={styles.demo}>
      <CTA inline>Primary CTA</CTA>
      <CTA inline secondary>
        Secondary CTA
      </CTA>
    </div>
    <p>Block CTA</p>
    <div className={styles.demoBlock}>
      <h1>Campagnolo Sram Shimano</h1>
      <p>Rouleur derby normandie. Cancellara muur, muur knockteberg muur-kapelmuur once koppenberg paris-roubaix</p>
      <CTA>Primary CTA</CTA>
      <CTA secondary>Secondary CTA</CTA>
    </div>
    <p>Disabled state</p>
    <div className={styles.demoBlock}>
      <CTA disabled>Primary CTA disabled</CTA>
      <CTA secondary disabled>
        Secondary CTA disabled
      </CTA>
    </div>
    <p>"Danger" mode</p>
    <div className={styles.demoBlock}>
      <CTA primary danger>
        Primary Danger
      </CTA>
      <CTA small danger>
        Small Danger
      </CTA>
    </div>
  </div>
);
